import {AfterContentChecked, Component, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {Tournament} from "../../model/tournament";
import {TournamentService} from "../../service/tournament.service";
import {MatAnchor, MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatCard, MatCardContent} from "@angular/material/card";
import {MatTableModule} from "@angular/material/table";
import {HeaderService} from "../../service/header.service";

@Component({
  selector: 'app-tournament-list',
  imports: [
    RouterLink, MatAnchor, MatIcon, MatCard, MatCardContent, MatButton, MatTableModule
  ],
  templateUrl: './tournament-list.component.html',
  standalone: true,
  styleUrl: './tournament-list.component.scss'
})
export class TournamentListComponent implements OnInit {

  tournaments: Tournament[];
  showInactive: boolean = false;

  constructor(
    private tournamentService: TournamentService
  ) {}

  ngOnInit() {
    this.tournamentService.getAll().subscribe(data => {
      this.tournaments = data;
    });
  }

  protected readonly Tournament = Tournament;

  clearDraw(tournament: Tournament) {
    this.tournamentService.clearDraw(tournament.id).subscribe(data => {
      this.tournamentService.getAll().subscribe(data => {
        this.tournaments = data;
      });
    })
  }

  getActiveTournaments(): Tournament[] {
    if (!this.tournaments) return [];
    return this.tournaments.filter(tournament => tournament.active);
  }

  getInactiveTournaments(): Tournament[] {
    if (!this.tournaments) return [];
    return this.tournaments.filter(tournament => !tournament.active);
  }

}
